// extracted by css-extract-rspack-plugin
export default {"menuButton":"Eq7pC","menuButtonOpen":"arBD0"};